import { defineComponent, useModel, openBlock, createElementBlock, createVNode, unref } from 'vue';
import { ElSlider } from 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                               */
/* empty css                                                                                                                                                      */
/* empty css                                                                                                                                                */

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "volume-container",
  props: {
    "modelValue": { default: 100 },
    "modelModifiers": {}
  },
  emits: ["update:modelValue"],
  setup(__props) {
    const model = useModel(__props, "modelValue");
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", { class: "se-volume-container" }, [
        createVNode(unref(ElSlider), {
          height: "6.25rem",
          vertical: "",
          modelValue: model.value,
          "onUpdate:modelValue": ($event) => model.value = $event,
          min: 0,
          max: 100
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=volume-container.vue.js.map
